import clsx from 'clsx';
import { memo } from 'react';

import { SharedStatusBadgeProps } from '../../types/SharedStatusBadgeProps';
import { Skeleton } from '../Skeleton/Skeleton';
import { Text } from '../Text/Text';
import './StatusBadge.css';

export type StatusBadgeProps =
  | (SharedStatusBadgeProps & { isLoading?: false })
  | {
      /** Replaces the badge with a pill-shaped skeleton while its value loads. */
      isLoading: true;
      status?: never;
      text?: never;
    };

export const StatusBadge = memo((props: StatusBadgeProps) => {
  if (props.isLoading) {
    return (
      <div className="eds-status-badge eds-status-badge--loading">
        <Skeleton radius="full" size="fill" />
      </div>
    );
  }

  const { status = 'neutral', text } = props;

  return (
    <div className={clsx('eds-status-badge', `eds-styles--status-${status}`)}>
      <Text truncate={1} variant="body-semi-s">
        {text}
      </Text>
    </div>
  );
});

StatusBadge.displayName = 'StatusBadge';
